function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "facebook_svg__login-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 266.89 266.89"
  }, props), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4267b2"
    },
    width: 266.89,
    height: 266.89,
    rx: 14.73,
    ry: 14.73
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M184.15 266.89V163.54h34.69l5.16-40.28h-39.85V97.54c0-11.66 3.24-19.61 20-19.61h21.33v-36a285.42 285.42 0 0 0-31.08-1.59c-30.75 0-51.81 18.77-51.81 53.24v29.71h-34.82v40.28h34.78v103.32Z"
  }));
};
export default SvgFacebook;